import React from 'react';
import moment from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';

import { AssignmentFilters } from 'features/assignment/AssignmentsFilter';
import { AssignmentFilterTypes } from 'features/assignment/enums';
import { DatePicker } from 'antd';

type Props = {
  filters: AssignmentFilters;
  onChange: (data: AssignmentFilters, type: AssignmentFilterTypes) => void;
};

export default function AssignmentDateFilter(props: Props) {
  const { filters, onChange } = props;

  const handleSelectDate =
    (type: AssignmentFilterTypes) => (date: RangeValue<any>) => {
      if (date) {
        return onChange(
          {
            ...filters,
            [type]: {
              startDate: date[0],
              endDate: date[1],
            },
          },
          type,
        );
      }

      onChange(
        {
          ...filters,
          [type]: undefined,
        },
        type,
      );
    };

  return (
    <DatePicker.RangePicker
      key="filterByDate"
      name="filterByDate"
      format="MM/DD/YYYY"
      separator="-"
      className="d-flex"
      value={
        filters[AssignmentFilterTypes.Date]
          ? [
              moment(filters[AssignmentFilterTypes.Date]?.startDate),
              moment(filters[AssignmentFilterTypes.Date]?.endDate),
            ]
          : undefined
      }
      onChange={handleSelectDate(AssignmentFilterTypes.Date)}
      data-id="dateFilterField"
    />
  );
}
